import { Bot, BotsService } from '../api';

interface ChatProviderResource {
  getList: (
    resource: string,
    params: any
  ) => Promise<{ data: Bot[]; total: number }>;
  create: (resource: string, params: any) => Promise<{ data: Bot }>;
  getOne: (resource: string, params: any) => Promise<{ data: Bot }>;
  update: (resource: string, params: any) => Promise<{ data: Bot }>;
}

export const chatsProvider: ChatProviderResource = {
  getList: async (resource, params) => {
    console.log(params);
    const { items } = await BotsService.listBots();
    if (!items) {
      return {
        data: [],
        total: 0,
      };
    }
    var data: Bot[] = [];
    console.log(params.filter.model_id);
    if (params.filter.model_id) {
      console.log(items);
      for (const item of items) {
        if (item.model_id === params.filter.model_id) {
          data.push(item);
        }
      }
    } else {
      data = items;
    }
    return {
      data: data,
      total: data.length,
    };
  },
  create: async (resource, params) => {
    console.log(params);
    const chat = await BotsService.botAdd(params.data);
    return { data: chat };
  },
  getOne: async (resource, params) => {
    const chat = await BotsService.getBot(params.id);
    return { data: chat };
  },
  update: async (resource, params) => {
    console.log(params);
    const {
      data: { name, api_type, api_token, start_message, model_id },
    } = params;
    const chat = await BotsService.updateBot(params.id, {
      name,
      api_type,
      api_token,
      start_message,
      model_id,
    });
    return { data: chat };
  },
};
